export default __webpack_public_path__ + "static/media/filtering-out.cbb92549.jpg";